import React from 'react'

export default function BookingDragHandle({ dragRef }) {
    return (
        <div ref={dragRef} className="grip cursor-grab">
            <i className="fas fa-grip-horizontal" />
        </div>
    )
}
